module.exports = __webpack_public_path__ + "img/logo-a@3x.2c8a1ef2.png";